import BasePerimeter from './base';

export default new BasePerimeter({
    purpose: 'globalReport',
    govern: {
        'can exportCSV': function () {
            return (this.isSuperAdmin() || this.isAdmin());
        },
        'can editAutomateReport': function () {
            return (this.isSuperAdmin() || this.isAdmin());
        },
    }
});